import React, { useEffect, useState } from 'react';
import {
  Grid, Segment, Table, Input, Button, Icon, Label, Breadcrumb,
} from 'semantic-ui-react';
import apiRequest from '../../app/common/api/apiClient';

const ROLE_COLORS = {
  superadmin: 'red',
  ksi: 'teal',
  knra: 'blue',
};

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    apiRequest('/api/users')
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error(err));
  }, []);

  const handleDelete = (user) => {
    if (!window.confirm(`Delete user ${user.email}?`)) return;
    apiRequest(`/api/users/${user.id}`, { method: 'DELETE' })
      .then((res) => {
        if (!res.ok) throw new Error();
        setUsers((prev) => prev.filter((u) => u.id !== user.id));
      })
      .catch(() => alert('Error deleting user.'));
  };

  const q = filter.toLowerCase();
  const filtered = users.filter(
    (u) =>
      !q ||
      (u.nom || '').toLowerCase().includes(q) ||
      (u.prenom || '').toLowerCase().includes(q) ||
      (u.email || '').toLowerCase().includes(q) ||
      (u.type_utilisateur || '').toLowerCase().includes(q) ||
      (u.fonctionpro || '').toLowerCase().includes(q) ||
      (u.etablissement || '').toLowerCase().includes(q)
  );

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={16}>
          <Breadcrumb>
            <Breadcrumb.Section active>Users</Breadcrumb.Section>
          </Breadcrumb>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={16}>
          <Segment.Group>
            <Segment attached='top'>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h5 style={{ margin: 0 }}>User management ({filtered.length})</h5>
                <Input
                  icon='search'
                  placeholder='Filter by name, email, role…'
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  size='small'
                />
              </div>
            </Segment>
            <Segment attached='bottom' style={{ overflowX: 'auto' }}>
              <Table celled selectable compact>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Last name</Table.HeaderCell>
                    <Table.HeaderCell>First name</Table.HeaderCell>
                    <Table.HeaderCell>Email</Table.HeaderCell>
                    <Table.HeaderCell>Role</Table.HeaderCell>
                    <Table.HeaderCell>Job title</Table.HeaderCell>
                    <Table.HeaderCell>Organisation</Table.HeaderCell>
                    <Table.HeaderCell>Phone</Table.HeaderCell>
                    <Table.HeaderCell>Created</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {filtered.length === 0 ? (
                    <Table.Row>
                      <Table.Cell colSpan={9} textAlign='center'>No users found.</Table.Cell>
                    </Table.Row>
                  ) : (
                    filtered.map((user) => (
                      <Table.Row key={user.id}>
                        <Table.Cell>{user.nom || '—'}</Table.Cell>
                        <Table.Cell>{user.prenom || '—'}</Table.Cell>
                        <Table.Cell>{user.email}</Table.Cell>
                        <Table.Cell>
                          <Label color={ROLE_COLORS[user.type_utilisateur] || 'grey'} size='small'>
                            {user.type_utilisateur}
                          </Label>
                        </Table.Cell>
                        <Table.Cell>{user.fonctionpro || '—'}</Table.Cell>
                        <Table.Cell>{user.etablissement || '—'}</Table.Cell>
                        <Table.Cell>{user.telephone || '—'}</Table.Cell>
                        <Table.Cell>
                          {user.date_utilisateur
                            ? new Date(user.date_utilisateur).toLocaleDateString('en-GB')
                            : '—'}
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                          <Button
                            size='small'
                            color='red'
                            icon
                            title='Delete user'
                            onClick={() => handleDelete(user)}
                          >
                            <Icon name='trash' />
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))
                  )}
                </Table.Body>
              </Table>
            </Segment>
          </Segment.Group>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default UsersPage;
